import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import LoadingEffect from '../../../../_metronic/layout/components/LoadingEffect'
import useApiService from '../../../services/ApiService/ApiService'
import axios from 'axios'
import { useAuth } from '../core/Auth'

const LoginSso = () => {
  const navigate = useNavigate()
  const location = useLocation()
  console.log('geldi')
  const { logout, saveAuth, setCurrentUser } = useAuth()

  useEffect(() => {
    logout()
    const referrer = document.referrer
    if (!isAllowedReferrer(referrer)) {
      if (location.pathname !== '/auth') {
        navigate('/auth', { replace: true })
      }
      return
    }

    const searchParams = new URLSearchParams(location.search)
    const token = searchParams.get('t')
    const encodedUrl = searchParams.get('token_check_uri')

    if (!encodedUrl || !token) return

    const getUser = async () => {
      try {
        const url = decodeURIComponent(encodedUrl)
        const headers = {
          Authorization: `Bearer ${token}`,
        }

        const response = await axios.post(`${url}auth/fetch-user`, {}, { headers })

        if (response.data.is_success) {
          const currentDate = new Date()
          // Token süresi için yaklaşık bir değer atanıyor
          currentDate.setHours(currentDate.getHours() + 3)
          currentDate.setMinutes(currentDate.getMinutes() + 50)

          const userData = {
            access_token: token,
            data: response.data.data,
            server_url: url,
            expire: currentDate.toISOString(),
          }

          const locations = userData.data.locations || []

          // Süresi dolmamış (is_expire: false) ilk lokasyonu bul
          // Eğer hiç uygun lokasyon yoksa, hata almamak için ilk lokasyonu seç (fallback)
          const selectedLocation = locations.find((loc: any) => loc.is_expire === false) || locations[0]

          saveAuth(userData)
          setCurrentUser(userData)

          localStorage.setItem('kt-auth-react-v', JSON.stringify(userData))
          localStorage.setItem('selectedLocation', JSON.stringify(selectedLocation))

          navigate('/home', { replace: true })
        }
      } catch (e) {
        console.error(e)
        navigate('/auth', { replace: true })
      }
    }

    getUser()
  }, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

  // İzin verilen referrer'ları kontrol eden bir fonksiyon
  const isAllowedReferrer = (referrer: any) => {
    // İzin verilen referrer URL'ini burada belirleyebilirsiniz
    const allowedReferrer = 'https://bayi.wisnet.com.tr/'
    // Referrer kontrolü
    return referrer.startsWith(allowedReferrer)
  }

  return <LoadingEffect />
}

export default LoginSso
